import Query from '../../../components/Report';

export const query = () => new Query('google-surfaces-share');
